import { useState, useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { useCurrentOrganization } from '@/stores/organization.store'
import { CompanyCreateEditSheet } from '@/components/crm/company-create-edit-sheet'

export const Route = createFileRoute('/_app/_crm/companies/new')({
  component: NewCompanyPage,
})

function NewCompanyPage() {
  useBreadcrumbFromRoute()

  const navigate = useNavigate()
  const { currentOrganization } = useCurrentOrganization()
  const [open, setOpen] = useState(true)

  // Handle sheet close - navigate back to companies list
  const handleOpenChange = (open: boolean) => {
    setOpen(open)
    if (!open) {
      navigate({ to: '/companies' })
    }
  }

  // Navigate to companies on mount if sheet is closed
  useEffect(() => {
    if (!open) {
      navigate({ to: '/companies' })
    }
  }, [open, navigate])

  if (!currentOrganization) {
    return null
  }

  return (
    <CompanyCreateEditSheet
      organizationId={currentOrganization.id}
      company={null}
      open={open}
      onOpenChange={handleOpenChange}
      onSuccess={(company) => {
        navigate({ to: '/companies/$id', params: { id: company.id } })
      }}
    />
  )
}
